import type React from 'react';

interface CardTopUpIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function CardTopUpIcon({ size = 24, ...props }: CardTopUpIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Icon_1">
        <g id="Group">
          <path
            id="Vector"
            d="M12.9811 12.8H11.1243C10.9474 12.8 10.8 12.9467 10.8 13.1227C10.8 13.2987 10.9474 13.4454 11.1243 13.4454H12.9811C13.1579 13.4454 13.3053 13.2987 13.3053 13.1227C13.3053 12.9467 13.1579 12.8 12.9811 12.8Z"
            fill="currentColor"
          />
          <path
            id="Vector (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.72 13.1226C10.72 12.9021 10.9036 12.72 11.1242 12.72H12.9811C13.2017 12.72 13.3853 12.9021 13.3853 13.1226C13.3853 13.3432 13.2017 13.5253 12.9811 13.5253H11.1242C10.9036 13.5253 10.72 13.3432 10.72 13.1226ZM11.1242 12.88C10.9912 12.88 10.88 12.9912 10.88 13.1226C10.88 13.2541 10.9912 13.3653 11.1242 13.3653H12.9811C13.1141 13.3653 13.2253 13.2541 13.2253 13.1226C13.2253 12.9912 13.1141 12.88 12.9811 12.88H11.1242Z"
            fill="currentColor"
          />
          <path
            id="Vector_2"
            d="M6.05268 10.5886H3.84215C3.65057 10.5886 3.48846 10.7426 3.48846 10.9333C3.48846 11.124 3.6432 11.278 3.84215 11.278H6.05268C6.24425 11.278 6.40636 11.124 6.40636 10.9333C6.40636 10.7426 6.25162 10.5886 6.05268 10.5886Z"
            fill="currentColor"
          />
          <path
            id="Vector (Stroke)_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.33844 10.9331C3.33844 10.6549 3.57252 10.4385 3.84212 10.4385H6.05265C6.33169 10.4385 6.55633 10.6569 6.55633 10.9331C6.55633 11.2114 6.32226 11.4278 6.05265 11.4278H3.84212C3.56309 11.4278 3.33844 11.2094 3.33844 10.9331ZM3.84212 10.7385C3.72857 10.7385 3.63844 10.8301 3.63844 10.9331C3.63844 11.0382 3.72327 11.1278 3.84212 11.1278H6.05265C6.1662 11.1278 6.25633 11.0362 6.25633 10.9331C6.25633 10.828 6.17151 10.7385 6.05265 10.7385H3.84212Z"
            fill="currentColor"
          />
          <path
            id="Vector_3"
            d="M8.2632 9.12207H3.84215C3.65057 9.12207 3.48846 9.27607 3.48846 9.46674C3.48846 9.6574 3.6432 9.8114 3.84215 9.8114H8.2632C8.45478 9.8114 8.61688 9.6574 8.61688 9.46674C8.61688 9.27607 8.46215 9.12207 8.2632 9.12207Z"
            fill="currentColor"
          />
          <path
            id="Vector (Stroke)_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.33844 9.46659C3.33844 9.18835 3.57252 8.97192 3.84212 8.97192H8.26318C8.54221 8.97192 8.76686 9.19036 8.76686 9.46659C8.76686 9.74483 8.53278 9.96126 8.26318 9.96126H3.84212C3.56309 9.96126 3.33844 9.74283 3.33844 9.46659ZM3.84212 9.27192C3.72857 9.27192 3.63844 9.3635 3.63844 9.46659C3.63844 9.57169 3.72327 9.66126 3.84212 9.66126H8.26318C8.37673 9.66126 8.46686 9.56968 8.46686 9.46659C8.46686 9.36149 8.38203 9.27192 8.26318 9.27192H3.84212Z"
            fill="currentColor"
          />
        </g>
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.08 5.62012H1.65686V6.51345H15.08V5.62012Z"
          fill="currentColor"
        />
        <path
          id="Union (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.50684 5.46997H15.23V6.6633H1.50684V5.46997ZM1.80684 5.76997V6.3633H14.93V5.76997H1.80684Z"
          fill="currentColor"
        />
        <path
          id="Union_2"
          d="M8.87581 14.0801H2.92212C1.90528 14.0801 1.08002 13.2587 1.08002 12.2467V4.91341C1.08002 3.90141 1.90528 3.08008 2.92212 3.08008H13.2379C14.2548 3.08008 15.08 3.90141 15.08 4.91341V7.55341C15.08 7.75874 14.9179 7.92008 14.7116 7.92008C14.5053 7.92008 14.3432 7.75874 14.3432 7.55341V4.91341C14.3432 4.30474 13.8495 3.81341 13.2379 3.81341H8.08002H2.92212C2.31054 3.81341 1.81686 4.30474 1.81686 4.91341V12.2467C1.81686 12.8554 2.31054 13.3467 2.92212 13.3467H8.87581C9.08212 13.3467 9.24423 13.5081 9.24423 13.7134C9.24423 13.9187 9.08212 14.0801 8.87581 14.0801Z"
          fill="currentColor"
        />
        <path
          id="Union (Stroke)_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.9221 3.22993C1.98742 3.22993 1.22999 3.98478 1.22999 4.91326V12.2466C1.22999 13.1751 1.98742 13.9299 2.9221 13.9299H8.87578C8.99993 13.9299 9.0942 13.8351 9.0942 13.7133C9.0942 13.5914 8.99993 13.4966 8.87578 13.4966H2.9221C2.22835 13.4966 1.66683 12.9388 1.66683 12.2466V4.91326C1.66683 4.22108 2.22835 3.66326 2.9221 3.66326H13.2379C13.9316 3.66326 14.4931 4.22108 14.4931 4.91326V7.55327C14.4931 7.67508 14.5874 7.76993 14.7116 7.76993C14.8357 7.76993 14.93 7.67508 14.93 7.55327V4.91326C14.93 3.98478 14.1726 3.22993 13.2379 3.22993H2.9221ZM0.929993 4.91326C0.929993 3.81775 1.82309 2.92993 2.9221 2.92993H13.2379C14.3369 2.92993 15.23 3.81775 15.23 4.91326V7.55327C15.23 7.84211 15.0001 8.06993 14.7116 8.06993C14.4231 8.06993 14.1932 7.84212 14.1932 7.55327V4.91326C14.1932 4.38812 13.7673 3.96326 13.2379 3.96326H2.9221C2.39269 3.96326 1.96683 4.38812 1.96683 4.91326V12.2466C1.96683 12.7717 2.39269 13.1966 2.9221 13.1966H8.87578C9.16426 13.1966 9.3942 13.4244 9.3942 13.7133C9.3942 14.0021 9.16426 14.2299 8.87578 14.2299H2.9221C1.82309 14.2299 0.929993 13.3421 0.929993 12.2466V4.91326Z"
          fill="currentColor"
        />
        <path
          id="Vector_4"
          d="M14.7391 9.82272C14.717 9.69805 14.6507 9.58805 14.5623 9.50005L12.5286 7.47605C12.2928 7.24138 11.8655 7.24138 11.6297 7.47605L9.58862 9.50005C9.50019 9.58805 9.44125 9.69805 9.41177 9.82272C9.38967 9.94738 9.39704 10.072 9.44862 10.1894C9.49283 10.3067 9.57388 10.402 9.68441 10.468C9.78756 10.5414 9.91283 10.578 10.0381 10.578H10.8265V12.1034C10.8265 12.2794 10.9739 12.426 11.1507 12.426H13.0076C13.1844 12.426 13.3318 12.2794 13.3318 12.1034V10.578H14.1202C14.2455 10.578 14.3707 10.5414 14.4739 10.4754C14.577 10.402 14.6581 10.3067 14.7097 10.1894C14.7612 10.072 14.7686 9.94738 14.7465 9.82272H14.7391ZM11.1507 9.92538H10.0749L12.0718 7.93805L14.076 9.92538H13.0002C12.8234 9.92538 12.676 10.072 12.676 10.248V11.7734H11.4676V10.248C11.4676 10.072 11.3202 9.92538 11.1434 9.92538H11.1507Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
